import PropTypes from 'prop-types';
import React from 'react';
import { CommonPropTypes, ComponentSizes } from 'vivino-js/commonPropTypes';

import CommunityReviewContainer, { CommunityReviewSkeleton } from '../CommunityReview';
import styles from './communityReviewItem.scss';

const CommunityReviewItem = (communityReviewProps) => {
  return (
    <div className={styles.reviewCard}>
      <CommunityReviewContainer
        size={ComponentSizes.Large}
        {...communityReviewProps}
        className={styles.reviewSection}
      />
    </div>
  );
};

export const CommunityReviewItemSkeleton = ({
  isUserActionEnabled = false,
  size = ComponentSizes.Base,
}) => {
  return (
    <div className={styles.reviewCard}>
      <CommunityReviewSkeleton isUserActionEnabled={isUserActionEnabled} size={size} />
    </div>
  );
};

CommunityReviewItemSkeleton.propTypes = {
  isUserActionEnabled: PropTypes.bool,
  size: CommonPropTypes.componentSize,
};

export default CommunityReviewItem;
